#import "../fragments/AutomationFields.graphql"

mutation SendBroadcast($id: ID!, $scheduledAt: DateTime) {
  sendBroadcast(id: $id, scheduledAt: $scheduledAt) {
    ...AutomationFields
  }
}
